import * as React from "react";
import Button from "~/common/elements/mobile/Button";
import { buttonSize, buttonStyle } from "~/common/elements/mobile/consts";
import Head from "~/common/layout/Head";
import { navigate } from "~/router";

const ProductCategoriesHeader = () => {
  const handleCreate = () => {
    navigate("pos.admin.products.categories.create");
  };

  return (
    <Head headTitle={"Products"}>
      <Button
        title="Create category"
        buttonStyle={buttonStyle.SECN}
        buttonSize={buttonSize.LG}
        onClick={handleCreate}
      />
    </Head>
  );
};

export default ProductCategoriesHeader;
